/**
 * Created by Administrator on 2017/6/26 0026.
 */
// import axios from 'axios'
import Url from '@/common/js/url'
var wx = require('weixin-js-sdk')
export default {
  install: function (Vue) {
    var wechat = Vue.wechat = Vue.prototype.$wechat = {}
//    注入微信权限认证
    wechat.config = function (ops) {
      var config = {
        debug: false,
        appId: ops.appId,
        timestamp: ops.timeStamp,
        nonceStr: ops.nonceStr,
        signature: ops.signature,
        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'hideMenuItems', 'chooseWXPay', 'getLocation']
      }
      wx.config(config)
    }
    wechat.pay = function (data) {
      var config = {
        timestamp: data.timeStamp + '',
        nonceStr: data.nonceStr,
        package: data.package,
        signType: 'MD5',
        paySign: data.paySign,
        success: function (res) {
          console.log(res)
          // 根据actP参数判断需要跳转至那个页面
          let actP = sessionStorage.getItem('actP')
          if (actP === '' || actP === 'null') {
            // 跳转到我的订单页面
            location.href = Url.api + 'wechat/index.html#/note/once'
          } else if (actP === 'inline') {
            // 跳转到报名详情
            location.href = Url.api + 'wechat/index.html#/regisDetail/' + sessionStorage.getItem('eventId') + '/' + sessionStorage.getItem('eventUserId')
          } else if (actP === 'out') {
            // 跳转到购买详情
            location.href = Url.api + 'wechat/index.html#/shopDetail/' +
              sessionStorage.getItem('eventId')
          }
        },
        error: function (res) {
          alert(JSON.stringify(res))
        }
      }
      wx.chooseWXPay(config)
    }
  }
}




// WEBPACK FOOTER //
// ./src/common/js/wechat.js